export default __webpack_public_path__ + "static/media/Stephy.78bf51bc.png";